// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:19:31

export default {
  "id": "opstacle-car-driving",
  "slug": "opstacle-car-driving",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/51951e60e1a94facb44b8e588c1ce21b-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/51951e60e1a94facb44b8e588c1ce21b/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Obstacle Car Driving",
      "description": "Obstacle Car Driving is an exciting and challenging endless driving game where precision and reflexes are key! Navigate through four unique environments, each packed with unpredictable obstacles that will test your driving skills.\nChoose from four different cars, each with its own handling and performance, and collect in-game currency as you drive. Use your earnings to unlock new vehicles and themes",
      "instructions": "For computer,\nUse Up Arrow Key, Right Arrow Key, W or D to move forward\nUser Down Arrow Key, Left Arrow Key, S or A to move backward\nPress Space to Pause and Resume the game\n\nFor Mobile,\nUse the pedals to move forward and backward",
      "genres": [
        "Adventure",
        "Racing & Driving"
      ],
      "tags": [
        "1player",
        "car",
        "obstacles",
        "vehicle"
      ]
    },
    "zh-CN": {
      "title": "障碍赛车驾驶",
      "description": "障碍汽车驾驶是一款激动人心且富有挑战性的无尽驾驶游戏，精确性和反应速度至关重要！在四个独特的环境中穿梭，每个环境都充满了不可预测的障碍，将考验你的驾驶技巧。\n从四种不同的汽车中选择，每种汽车都有其独特的操控性和性能，并在驾驶过程中收集游戏货币。使用你的收入解锁新车辆和主题。",
      "instructions": "电脑版：\n使用上箭头键、右箭头键、W键或D键前进\n使用下箭头键、左箭头键、S键或A键后退\n按空格键暂停和继续游戏\n\n手机版：\n使用踏板前进和后退",
      "genres": [
        "冒险",
        "竞速与驾驶"
      ],
      "tags": [
        "1玩家",
        "汽车",
        "障碍物",
        "车辆"
      ]
    },
    "zh-TW": {
      "title": "障礙車駕駛",
      "description": "障礙車輛駕駛是一款刺激且挑戰無窮的駕駛遊戲，精準度和反應速度是關鍵！穿梭於四種獨特環境中，每個環境都充滿了不可預測的障礙，將挑戰你的駕駛技巧。\n從四種不同的車輛中選擇，每種車輛都有其獨特的操控性和性能，並在駕駛過程中收集遊戲內的貨幣。使用你的收入來解鎖新車輛和主題。",
      "instructions": "對電腦玩家：\n使用上箭頭鍵、右箭頭鍵、W或D鍵向前移動\n使用下箭頭鍵、左箭頭鍵、S或A鍵向後移動\n按空格鍵暫停和恢復遊戲\n\n對手機玩家：\n使用踏板來移動前進和後退",
      "genres": [
        "冒險",
        "賽車與駕駛"
      ],
      "tags": [
        "1 玩家",
        "車輛",
        "障礙物",
        "車輛"
      ]
    },
    "zh-HK": {
      "title": "障礙車駕駛",
      "description": "障礙車輛駕駛是一款刺激又挑戰無盡的駕駛遊戲，精準和反應速度是關鍵！穿梭於四個獨特的環境中，每個環境都充滿了不可預測的障礙，將考驗你的駕駛技巧。\n從四種不同的車輛中選擇，每種車輛都有其獨特的操控和性能，並在駕駛過程中收集遊戲內的貨幣。使用你的收入來解鎖新車輛和主題。",
      "instructions": "對電腦版：\n使用上箭頭鍵、右箭頭鍵、W 或 D 鍵向前移動\n使用下箭頭鍵、左箭頭鍵、S 或 A 鍵向後移動\n按空格鍵以暫停及恢復遊戲\n\n對手機版：\n使用踏板向前及向後移動",
      "genres": [
        "冒險",
        "賽車及駕駛"
      ],
      "tags": [
        "1玩家",
        "車輛",
        "障礙物",
        "車輛"
      ]
    },
    "ja": {
      "title": "障害物カーオートドライビング",
      "description": "障害物カードライビングは、精度と反応が鍵となる刺激的で挑戦的な無限のドライビングゲームです！4つのユニークな環境を通過し、それぞれが予測不可能な障害物であなたの運転スキルを試すものです。\n\n4種類の異なる車を選び、それぞれの操縦と性能を楽しみながらゲーム内通貨を集めます。得た収益を使って、新しい車両やテーマを解除しましょう。",
      "instructions": "コンピューター用\n上矢印キー、右矢印キー、WまたはDキーで前に進む\n下矢印キー、左矢印キー、SまたはAキーで後ろに進む\nスペースキーを押してゲームを一時停止および再開\n\nモバイル用\nペダルを使用して前に進み、後ろに進む",
      "genres": [
        "アドベンチャー",
        "レース&ドライビング"
      ],
      "tags": [
        "1プレイヤー",
        "車",
        "障害物",
        "車両"
      ]
    },
    "ko": {
      "title": "장애물 차량 운전",
      "description": "장애물 자동차 드라이빙은 정확성과 반사신경이 중요한 흥미롭고 도전적인 무한 드라이빙 게임입니다! 네 가지 독특한 환경을 통해 예측할 수 없는 장애물을 통해 운전 기술을 테스트하세요.\n네 가지 다른 자동차 중 하나를 선택하여 각각의 핸들링과 성능을 경험하고, 운전하면서 게임 통화를 모으세요. 벌은을 사용하여 새로운 차량과 테마를 해금하세요.",
      "instructions": "컴퓨터용\n위쪽 방향키, 오른쪽 방향키, W 또는 D 키로 앞으로 이동\n아래쪽 방향키, 왼쪽 방향키, S 또는 A 키로 뒤로 이동\n스페이스바를 눌러 게임을 일시정지하고 재개\n\n모바일용\n휠을 사용하여 앞으로와 뒤로 이동",
      "genres": [
        "모험",
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "1플레이어",
        "차량",
        "장애물",
        "차량"
      ]
    },
    "fr": {
      "title": "Conduite de voiture avec obstacles",
      "description": "Obstacle Car Driving est un jeu de conduite épuisant et stimulant, un jeu de conduite sans fin où la précision et la réactivité sont essentielles ! Naviguez à travers quatre environnements uniques, chacun regorgeant d'obstacles imprévisibles qui testeront vos compétences en conduite.\nChoisissez parmi quatre voitures différentes, chacune ayant son propre comportement et performance, et collectez de l'argent virtuel tout en conduisant. Utilisez vos gains pour déverrouiller de nouveaux véhicules et thèmes.",
      "instructions": "Pour ordinateur,\nUtilisez la flèche vers le haut, la flèche vers la droite, W ou D pour avancer\nUtilisez la flèche vers le bas, la flèche vers la gauche, S ou A pour reculer\nAppuyez sur la barre d'espace pour mettre en pause et reprendre le jeu\n\nPour mobile,\nUtilisez les pédales pour avancer et reculer",
      "genres": [
        "Aventure",
        "Course et Conduite"
      ],
      "tags": [
        "1 joueur",
        "voiture",
        "obstacles",
        "véhicule"
      ]
    }
  }
};
